import React from 'react';
import { Text, YStack, Image } from 'tamagui';

import { homeGuardianLogo } from '../../../assets';

interface AppVersionProps {
  hubId?: string | null;
  hubName?: string | null;
}

export const AppVersion: React.FC<AppVersionProps> = ({ hubId, hubName }) => (
  <YStack
    justifyContent="center"
    alignItems="center"
    width={293}
    height={432}
    gap="$2"
    padding="$3">
    <Image source={{ uri: homeGuardianLogo }} alt="Delta Logo" width={140} height={140} />
    <Text color="white12" fontFamily="$heading" fontSize="$6" fontWeight="$5">
      App Version 1.0
    </Text>
    {hubId && (
      <>
        <Text color="white12" fontFamily="$body" fontSize="$3" textAlign="center" marginBottom={0}>
          Hub ID
        </Text>
        <Text color="white12" fontFamily="$body" fontSize="$2" textAlign="center" marginTop={0}>
          {hubId}
        </Text>
      </>
    )}
    {hubName && (
      <>
        <Text color="white12" fontFamily="$body" fontSize="$3" textAlign="center" marginBottom={0}>
          Hub Name
        </Text>
        <Text color="white12" fontFamily="$body" fontSize="$2" textAlign="center" marginTop={0}>
          {hubName}
        </Text>
      </>
    )}
  </YStack>
);
